module.exports = __webpack_public_path__ + "9d081de91864f4dbd8c374f37f9380d7.png";